import type { Encoded } from "@aeternity/aepp-sdk";
import { WalletInfo } from "@aeternity/aepp-sdk/es/aepp-wallet-communication/rpc/types";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useAccounts = defineStore(
  "accounts",
  () => {
    const accounts = ref<Encoded.AccountAddress[]>([]);
    const activeAccount = ref<Encoded.AccountAddress>();
    const walletInfo = ref<WalletInfo>();
    const slippage = ref<number>(3);

    function setActiveAccount(account?: Encoded.AccountAddress) {
      activeAccount.value = account;
    }

    function setAccounts(_accounts: Encoded.AccountAddress[]) {
      accounts.value = _accounts;
    }

    return {
      accounts,
      activeAccount,
      walletInfo,

      setActiveAccount,
      setAccounts,
      slippage,
    };
  },
  { persist: true }
);
